// extracted by mini-css-extract-plugin
module.exports = {"row":"_9ae37f7a","priceLabel":"_71d0279b","topLine":"_b3b02a95","priceStrike":"_7dac0bcf"};